import './PageLoading.scss';
import { selectCommon } from '../../store/commonSlice';
import { useAppSelector } from '../../store/hooks';
import Image from '../Image/Image';

function PageLoading(): JSX.Element {
  const common = useAppSelector(selectCommon);
  const pageLoading = common.pageLoading;

  return (
    <div className={`page-loader ${pageLoading ? 'show' : ''}`}>
      <Image
        name='npbs-logo-animation.gif'
        alt='page loading animation gif'
        classes='page-loader__icon'
        width='150'
        height='150'
      />
    </div>
  );
}

export default PageLoading;
